import React from 'react';
import { Deal } from '../types/pipeline';
import { X, DollarSign, Clock, FileText, ChevronRight } from 'lucide-react';
interface RecordSelectorModalProps {
  deals: Deal[];
  stage: string;
  onSelect: (deal: Deal) => void;
  onClose: () => void;
}
export function RecordSelectorModal({
  deals,
  stage,
  onSelect,
  onClose
}: RecordSelectorModalProps) {
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 0
    }).format(amount);
  };
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm animate-in fade-in duration-200" data-id="element-291">
      <div className="bg-white rounded-lg shadow-2xl w-full max-w-2xl max-h-[80vh] flex flex-col animate-in zoom-in-95 duration-200" data-id="element-292">
        {/* Header */}
        <div className="px-6 py-5 border-b border-slate-200 flex items-center justify-between bg-slate-50 rounded-t-lg" data-id="element-293">
          <div data-id="element-294">
            <h2 className="text-xl font-bold text-slate-900" data-id="element-295">
              Select Loan Application
            </h2>
            <p className="text-sm text-slate-500 mt-1" data-id="element-296">
              {deals.length} applications in{' '}
              <span className="font-medium text-slate-700" data-id="element-297">{stage}</span>
            </p>
          </div>
          <button onClick={onClose} className="p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-200 rounded-lg transition-colors" aria-label="Close modal" data-id="element-298">
            <X className="w-5 h-5" data-id="element-299" />
          </button>
        </div>

        {/* List */}
        <div className="flex-1 overflow-y-auto p-4 space-y-3 bg-slate-50/50" data-id="element-300">
          {deals.map(deal => <button key={deal.id} onClick={() => onSelect(deal)} className="w-full bg-white border border-slate-200 rounded-lg p-4 hover:border-blue-400 hover:shadow-md transition-all text-left group flex items-center justify-between" data-id="element-301">
              <div className="flex-1 min-w-0" data-id="element-302">
                <div className="flex items-center justify-between mb-2" data-id="element-303">
                  <h3 className="text-lg font-semibold text-slate-900 group-hover:text-blue-700 transition-colors truncate pr-4" data-id="element-304">
                    {deal.borrowerName}
                  </h3>
                  <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-slate-100 text-slate-800 border border-slate-200" data-id="element-305">
                    {deal.loanType}
                  </span>
                </div>

                <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 text-sm text-slate-500" data-id="element-306">
                  <div className="flex items-center" data-id="element-307">
                    <DollarSign className="w-4 h-4 mr-1.5 text-slate-400" data-id="element-308" />
                    <span className="font-medium text-slate-700" data-id="element-309">
                      {formatCurrency(deal.amount)}
                    </span>
                  </div>
                  <div className="flex items-center" data-id="element-310">
                    <Clock className="w-4 h-4 mr-1.5 text-slate-400" data-id="element-311" />
                    <span data-id="element-312">{deal.daysInStage} days in stage</span>
                  </div>
                  <div className="hidden sm:flex items-center" data-id="element-313">
                    <FileText className="w-4 h-4 mr-1.5 text-slate-400" data-id="element-314" />
                    <span data-id="element-315">{deal.probability}% probability</span>
                  </div>
                </div>
              </div>

              <div className="ml-4 pl-4 border-l border-slate-100 flex items-center justify-center" data-id="element-316">
                <div className="p-2 rounded-full bg-slate-50 group-hover:bg-blue-50 transition-colors" data-id="element-317">
                  <ChevronRight className="w-5 h-5 text-slate-400 group-hover:text-blue-600" data-id="element-318" />
                </div>
              </div>
            </button>)}
        </div>

        {/* Footer */}
        <div className="px-6 py-4 border-t border-slate-200 bg-white rounded-b-lg flex justify-end" data-id="element-319">
          <button onClick={onClose} className="px-4 py-2 text-sm font-medium text-slate-700 hover:bg-slate-100 rounded-lg transition-colors" data-id="element-320">
            Cancel
          </button>
        </div>
      </div>
    </div>;
}